// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatamusd } from "../../../icons/mono/build/icon-statamusd.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatamusdIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatamusd.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatamusdIcon.displayName = 'StatamusdIcon';
}

export default StatamusdIcon;